module.exports = __webpack_public_path__ + "static/media/trip-image-1.1d6158ac.png";